export class StudentExtraInfo {

    studentId           : number;
    extraInfoId         : number;
    extraInfoName       : string;
    extraInfoDisplayName: string;
    active              : boolean;
    observations        : string;

}
